var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsAppRunner32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-Fusion_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-Fusion_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-Fusion_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.163,22.544 L9.456,21.837 L3,28.293 L3,25 L2,25 L2,29.5 C2,29.776 2.224,30 2.5,30 L7,30 L7,29 L3.707,29 L10.163,22.544 Z M29.5,2 L25,2 L25,3 L28.293,3 L22.146,9.147 L22.853,9.854 L29,3.707 L29,7 L30,7 L30,2.5 C30,2.224 29.776,2 29.5,2 L29.5,2 Z M18,26 L26,26 L26,18 L18,18 L18,26 Z M27,17.5 L27,26.5 C27,26.776 26.776,27 26.5,27 L17.5,27 C17.224,27 17,26.776 17,26.5 L17,17.5 C17,17.224 17.224,17 17.5,17 L26.5,17 C26.776,17 27,17.224 27,17.5 L27,17.5 Z M6,14 L14,14 L14,6 L6,6 L6,14 Z M15,5.5 L15,14.5 C15,14.776 14.776,15 14.5,15 L5.5,15 C5.224,15 5,14.776 5,14.5 L5,5.5 C5,5.224 5.224,5 5.5,5 L14.5,5 C14.776,5 15,5.224 15,5.5 L15,5.5 Z M14.5,17 L5.5,17 C5.224,17 5,17.224 5,17.5 L5,24.172 L6,23.172 L6,18 L14,18 L14,26 L8.828,26 L7.828,27 L14.5,27 C14.776,27 15,26.776 15,26.5 L15,17.5 C15,17.224 14.776,17 14.5,17 L14.5,17 Z M26,8.828 L27,7.828 L27,14.5 C27,14.776 26.776,15 26.5,15 L17.5,15 C17.224,15 17,14.776 17,14.5 L17,5.5 C17,5.224 17.224,5 17.5,5 L24.172,5 L23.172,6 L18,6 L18,14 L26,14 L26,8.828 Z",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsAppRunner32);
export default __webpack_public_path__ + "static/media/Arch_AWS-App-Runner_32.b8c9bd2f6472c07b94984a26a1c1e198.svg";
export { ForwardRef as ReactComponent };